<template>
    <div>
    <b-card>
        <template slot="header">
            <card-header
                    :header-title="`Filters`"
                    :button="true"
                    :button-title="`Reload`"
                    :button-icon="`fa fa-rotate-right`"
                    :button-event="loadReportClicked"
                    :disabled="loading"
            />
        </template>

        <b-row>
            <b-col xl="4" lg="12">
                <b-form-group
                        label="Date"
                        :label-for="date"
                        :label-cols="2"
                        :horizontal="true"
                >
                    <vue-picker
                            v-model="date"
                            id="date"
                            :max-date="dateLimit"
                            :first-day-of-week="1"
                            :format="config.format"
                            :range="config.range"
                            :no-header="true"
                            :dark="config.dark"
                            :disabled-weekly="config.disabledDays"
                            :no-value-to-custom-elem="true"
                    >
                        <b-form-input
                                type="text"
                                autocomplete="off"
                                :value="date"
                        />
                    </vue-picker>
                </b-form-group>

                <b-form-group
                        label="App"
                        label-for="app"
                        :label-cols="2"
                        :horizontal="true"
                >
                    <b-form-select
                            id="app"
                            v-model="selectedApp"
                            :options="appsOptions"
                    />
                </b-form-group>

                <b-form-group
                        label="Tariffs"
                        label-for="tariffs"
                        :label-cols="2"
                        :horizontal="true"
                >
                    <multiselect
                            id="tariffs"
                            v-model="selectedTariffs"
                            :options="tariffsOptions"
                            multiple
                    />
                </b-form-group>

                <b-form-group
                        label="Subscription"
                        label-for="subscription"
                        :label-cols="2"
                        :horizontal="true"
                >
                    <multiselect
                            id="subscription"
                            v-model="selectedSubscriptions"
                            :options="subscriptionOptions"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </b-card>
    <b-table/>
    </div>
</template>

<script>
    import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import { APPLE_APPS_LOAD_APPS, APPLE_APPS_GET_APPS } from '@/store/constants';
    import { extractData } from '@/libs/backend/apimapper';
    import Multiselect from 'vue-multiselect';


    export default {
        name: "SalesReportFilters",
        components: {
            CardHeader,
            'vue-picker': VueCtkDateTimePicker,
            Multiselect,
        },
        data() {
            return {
                loading: false,
                selectedApp: [],
                date: '',
                date2: '',
                dateLimit: '',
                tariffsOptions: [],
                selectedTariffs: null,
                selectedSubscriptions: null,
                config: {
                    format: 'YYYY-MM-DD',
                    formatted: 'll',
                    range: false,
                    overlay: true,
                    dark: true,
                    disabledDays: [1, 2, 3, 4, 5, 6],
                    firstDay: 1,
                },
            }
        },
        computed: {
            formattedFilters() {
                return {
                    date: this.date,
                    app: this.selectedApp,
                    tariffs: this.selectedTariffs,
                    subs: this.selectedSubscriptions,
                }
            },

            subscriptionOptions() {
                return ['Renewal', 'New'];
            },

            appsOptions() {
                return this.$store.getters[APPLE_APPS_GET_APPS].map(el => {
                    return {
                        text: el.name,
                        value: el.id,
                    };
                });
            },
        },
        async created() {
            this.loading = true;
            await this.loadAppleApps();
            await this.loadTariffs();
            this.setDateToSecondRecentSunday();
            this.setDateLimit();
            this.setDefaultApp();
            this.loading = false;
        },
        methods: {
            loadReportClicked() {
                this.$emit('loadReportClicked', this.formattedFilters);
            },

            setDateToSecondRecentSunday() {
                const today = new Date();
                this.date = this.formatDate((new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 6)).toISOString());
            },

            setDateLimit() {
                const today = new Date();
                this.dateLimit = this.formatDate((new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 1)).toISOString());
            },

            formatDate(date) {
                return date.substring(0, 10);
            },

            async loadAppleApps() {
                //if(!this.$store.getters[APPLE_APPS_GET_APPS])
                await this.$store.dispatch(APPLE_APPS_LOAD_APPS);
            },

            async loadTariffs() {
                const tariffs = await this.$store.dispatch('backendTalker', {
                    request: 'tariffs_list',
                });

                if (!tariffs) {
                    return Promise.reject('Incorrect Apple apps data from backend');
                }

                this.tariffsOptions = tariffs.data.map(el => el.productId);
            },

            setDefaultApp() {
                this.selectedApp = this.appsOptions[0].value;
            },
        }
    }
</script>

<style scoped>

</style>